<template>
  <vue-js-modal
    v-if="output"
    :key="reload"
    id="agOutputModal"
    class="agModal"
    name="agOutputModal"
    draggable=".card-header"
    width="75%"
    height="85%"
    :shiftX=".5"
    :shiftY=".25"
    :resizable="true"
    :clickToClose="false">
    <b-card>
      <template #header>
        <h4 v-if="disableUI || isLoading" class="agModal-title">View Output {{output.shortname}}</h4>
        <h4 v-else class="agModal-title">Edit Output {{output.shortname}}</h4>
      </template>

      <div class="agInputGroup agInputGroupCentered">
        <label>Source:</label>
        <b-input type="text" v-model="srcStr" autocomplete="false" disabled></b-input>
      </div>
      <b-input-group size="md" prepend="Name">
        <b-input type="text" v-model="output.name" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <b-input-group size="md" prepend="Description">
        <b-input type="text" v-model="output.description" autocomplete="false" :disabled="disableUI || isLoading"></b-input>
      </b-input-group>
      <hr />
        <input
          type="checkbox"
          v-model="output.hasBreakpoint"
          :disabled="disableUI || isLoading"/>
        <label>Has Breakpoint</label>
      <hr />
      <ag-fields-selector
        ref="fieldsSelector"
        :node="output"
        :disableUI="disableUI || isLoading"
        :connections="connections"
        :hasChildObjects="true"
        @refreshedSchemas="refreshedSchemas"
        @connectionChanged="connectionChanged"
        @layerChanged="layerChanged">
      </ag-fields-selector>
      <div v-if="showGeometry" class="agInputGroup agInputGroupCentered">
        <input type="checkbox" v-model="output.includeGeometry" :disabled="disableUI || isLoading" />
        <label>Include geometry</label>
      </div>
      <div class="agInputGroup agInputGroupCentered">
        <label>Action:</label>
        <b-form-select
          class="agSmallInput"
          v-model="output.action"
          :options="actions"
          :disabled="disableUI || actions.length == 0"
        ></b-form-select>
      </div>
      <hr />
      <div id="agOutputModal-dests">
        <div v-if="output.dest" class="agInputGroup agInputGroupCentered">
          <label>Result Destination:</label>
          <br/>
          <b-input type="text" :value="destName" class="agInput agExtraSmallInput" disabled></b-input>
        </div>
        <div  v-if="dest_error" class="agInputGroup agInputGroupCentered agInputGroupInline">        
          <label>Error Destination:</label>
          <br/>
          <input
            type="checkbox"
            v-model="dest_error.selected"
            :disabled="disableUI || isLoading"
            @click="destCheckbox_change(dest_error)"/>  
          <b-input type="text" :value="destName_error" class="agInput agExtraSmallInput" disabled></b-input>
        </div>
      </div>

      <template #footer>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <div v-else-if="modalMessage">
          <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
        </div>

        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="primary"
          :disabled="disableUI || isLoading"
          @click="saveButton_click">
          Save
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          :disabled="disableUI || isLoading"
          @click="deleteButton_click">
          Delete
        </b-button>
      </template>
    </b-card>

    <!-- delete modal -->
    <b-modal
      class="agModal"
      ref="deleteModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Output</h4>
      </template>
      Are you sure you want to delete output
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">
          Cancel
        </b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click">
          Delete
        </b-button>
      </template>
    </b-modal>

  </vue-js-modal>  
</template>


<script>

// components
import FieldsSelector from "comp/ui/FieldsSelector"

// modules
import Vue from "vue";
import Server from "src/server";
import Util from "src/util/util";

export default {
  name: "ag-output-modal",
  components: {
    "ag-fields-selector": FieldsSelector
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean,
  },
  data() {
    return {
      output: null,
      reload:0,
      reloadFields: 0,
      isLoading: false,
      modalMessage: "",
      modalMessageClass: "",
      children: [],
      showGeometry: false,
      actions: [],
      dest_error: null,
    };
  },
  computed: {

    name() {
      if (this.output.name) {
        return this.output.name;
      }
      return this.output.shortname;
    },

    srcStr() {
      if (!this.output.src || this.output.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.output.src.length; i++) {
        var src = this.output.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    destName() {
      if (this.output.dest) 
        return this.output.dest.shortname;
      return "";
    },

    destName_error() {
      if (this.output.dest_error) 
        return this.output.dest_error.shortname;
      return "";
    },

    connections() {
      var inputOutputConnections = this.$store.state.connStore.connections;
      if(this.output.connection){
        let newConn = inputOutputConnections.find(c => c._id == this.output.connection._id)
        this.output.connection = newConn;
      }
      return inputOutputConnections.filter(c => c.type != "geometry").map(b => {return {value: b, text: b.name};});
    },

    layerLabel() {
      if (this.output.connection && this.output.connection.type == "max") {
        return "Object:";
      }
      return "Layer:";
    },

    filteredFields() {
      if (!this.fieldSearchText) return this.fields;

      var filteredFields = this.fields.filter(
        (a) =>
          (a.field &&
            a.field.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1) ||
          (a.alias &&
            a.alias.toLowerCase().indexOf(this.fieldSearchText.toLowerCase()) >
              -1)
      );
      return filteredFields;
    },

    nextChild() {
      var num = 0;
      for (var i = 0; i < this.output.childObjects.length; i++) {
        var child = this.output.childObjects[i];
        var childNum = parseInt(child.shortname.replace("C-", ""));
        if (num <= childNum) {
          num = childNum;
        }
      }
      return num + 1;
    },
  },

  methods: {
    // UI Events

    destCheckbox_change(dest){
      dest.selected = !dest.selected;
    },

    cancelButton_click() {
      this.hide();
    },

    async saveButton_click() {
      this.modalMessage = "";

      // remove the last empty, placeholder child object
      this.output.childObjects.pop();

      // empty fields and child object fields
      this.output.fields = [];
      for (var i = 0; i < this.output.childObjects.length; i++) {
        var child = this.output.childObjects[i];
        child.fields = [];
      }

      // repopulate fields
      for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
        var field = this.$refs.fieldsSelector.fields[i];
        if (field.enabled) {
          if (field.child) {
            var child = this.output.childObjects.find(
              (a) => a.shortname == field.child
            );
            var prefix = child.shortname + ": ";
            var fieldName = field.field;
            fieldName = fieldName.substring(prefix.length, fieldName.length);
            child.fields.push(fieldName);
          } else {
            var fieldName = field.field;
            this.output.fields.push(fieldName);
          }
        }
      }

      // save only selected dests (output.dest will always be selected)
      // dest_error
      if(this.dest_error.selected) {
        this.output.dest_error = JSON.parse(JSON.stringify(this.dest_error));
        delete this.output.dest_error["selected"];
      }
      else
        this.output.dest_error = null;

      var node = {
        object: this.output,
        type: "output",
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node,
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "output",
          object: result.data.node
        };
        this.hide();
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.output,
        type: "output",
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node,
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide();
    },

   
    // emitted events 

    refreshedSchemas() {
      var fields = this.output.fields;
      console.log(`output's refreshedSchemas - ${JSON.stringify(fields[fields.length-1])}`);
      this.setActions();
      this.$emit("reloadNodes");
    },

    connectionChanged() {
      if(this.output.connection && (this.output.connection.type == "esri" || this.output.connection.type == "agol"))
        this.showGeometry = true;
      else
        this.showGeometry = false;

      this.setActions();
    },

    layerChanged() {
      this.setActions();
    },

    // other
    async show() {
      await this.setOutput();
      await Vue.nextTick();
      await this.reset();
      this.$modal.show("agOutputModal");
    },

    hide() {
      this.$modal.hide("agOutputModal");
    },

    async reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";

      if (this.output.connection && (this.output.connection.type == "esri" || this.output.connection.type == "agol"))
        this.showGeometry = true;
      else 
        this.showGeometry = false;

      // add an empty child object as a placeholder
      if (this.output.childObjects.length == 0 || this.output.childObjects[this.output.childObjects.length - 1].name != "") {
        this.output.childObjects.push({
          name: "",
          shortname: "C-" + this.nextChild,
          fields: [],
        });
      }
            
      // init dests w/ selected attr (output.dest will always be selected)
      // dest_error
      if(this.output.dest_error) {
        this.dest_error = JSON.parse(JSON.stringify(this.output.dest_error));
        this.dest_error.selected = true;
      }
      else
        this.dest_error = {selected: false, shortname: null, _id: null};

      this.setActions();
      // Vue.nextTick(); not working in this case. Use longer timeout
      setTimeout(() => {  
        this.$refs.fieldsSelector.reset();
      }, 250);
    },

    async setOutput() {
      if(this.node && this.node.type == "output") 
        this.output = this.workflow.outputs.find((object) => object._id == this.node.object._id);
      else 
        this.output = null;
    },

    setActions() {
      this.actions = [];
      if (this.output.connection && this.output.layer) {
        var schema = this.output.connection.schemas.find(schema => schema.id == this.output.layer);
        if(schema)
          this.actions = schema.actions;
      }
    },
  } 
};
</script>


<style scoped lang="css">
#agOutputModal-childObjects {
  position: relative;
  left: 476px;
}

.agOutputModal-childObject {
  margin-left: 50px;
}

.agOutputModal-childObject label {
  text-align: right;
}

.agOutputModal-deleteChildObjectButton {
  position: absolute;
  margin-left: 10px;
  margin-top: 5px;
  font-size: 20px;
}

#agOutputModal-fieldsTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  margin: 5px 0px 0px 100px;
  overflow: auto;
  border-collapse: collapse;
}

#agOutputModal-fieldsTableSpinner {
  position: relative;
  left: -500px;
  top: 75px;
}

#agOutputModal-fieldSearch {
  width: calc(100% - 200px);
}

#agOutputModal-dests {
  display: flex;
  position: relative;
  justify-content: space-evenly;
  left: 25px;
}

</style>

<style lang="css">

#agOutputModal-fieldsTable .agOutputModal-fieldsTableCell {
  min-width: 125px !important;
}


</style>



// WEBPACK FOOTER //
// src/components/nodes/OutputModal.vue